import { Translate } from 'react-redux-i18n'
import {
  CELL_OPTIONS,
  MAX_INPUT_LENGTH,
  REGEXP_CHARACTERS_BLOCK,
  TABLE_FILTER_TITLE,
} from '../../constant'

export const getSchema = () => {
  return TABLE_FILTER_TITLE.map(({ key, label }) => {
    const { cellType: Cell, ...other } = CELL_OPTIONS[key]

    return {
      ...other,
      colId: key,
      title: <Translate value={label} />,
      render: (val, otherProps) => <Cell val={val} {...otherProps} />,
    }
  })
}

export const keyById = (payload) => {
  if (!payload.length) return {}

  const result = {}
  payload.forEach((item) => {
    result[item.organizationId] = {
      ...item,
      status: {
        activeStatusName: item.activeStatusName,
        activeStatusId: item.activeStatusId,
      },
    }
  })

  return result
}

export const initListChecked = (prevListChecked, metaData) => {
  if (!metaData || !metaData.length) return {}

  if (Object.keys(prevListChecked).length) return prevListChecked

  return metaData.reduce((prev, cur) => {
    return {
      ...prev,
      [cur]: false,
    }
  }, {})
}

export const removeSpecials = (value) =>
  value
    .slice(0, MAX_INPUT_LENGTH)
    .split('')
    .filter((item) => !REGEXP_CHARACTERS_BLOCK.includes(item))
    .join('')
